module.exports = "<p>\r\n  edit-order works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/edit-order/edit-order.component.html
// module id = ./src/app/edit-order/edit-order.component.html
// module chunks = main